import { Box, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import { useTranslation } from "react-i18next";

function EmptyDatesView({ OnAddDate }) {
  const { t } = useTranslation();
  return (
    <Box textAlign="center" py={5}>
      <CalendarMonthIcon
        sx={{ width: "80px", height: "80px", color: "grey.400" }}
      />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {t("trajectories.wizard.emptyDatesView.emptyTitle")}
      </Typography>
      <Typography variant="body1" color="HighlightText" sx={{ mt: 1 }}>
        {t("trajectories.wizard.emptyDatesView.emptySubtitle")}
      </Typography>
      <MDButton
        variant="contained"
        color="info"
        size="medium"
        sx={{ mt: 3 }}
        onClick={() => OnAddDate("add")}
      >
        <Icon>add</Icon>&nbsp; {t("trajectories.wizard.emptyDatesView.addNew")}
      </MDButton>
    </Box>
  );
}
// Define PropTypes
EmptyDatesView.propTypes = {
  OnAddDate: PropTypes.func.isRequired, // Validate that OnAddDate is a required function
};
export default EmptyDatesView;
